import { render } from "./IdentificationStatus.vue?vue&type=template&id=8dbd3780&scoped=true"
import script from "./IdentificationStatus.vue?vue&type=script&lang=js"
export * from "./IdentificationStatus.vue?vue&type=script&lang=js"

import "./IdentificationStatus.vue?vue&type=style&index=0&id=8dbd3780&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dbd3780"]])

export default __exports__